import React, { useState, useEffect } from 'react';
import RouterScreen from './containers/RouterScreen'
import './App.css';
import { withOrientationChange, isMobile } from "react-device-detect";
import MobileText from './components/MobileText';

function App(props) {
  const { isPortrait, isLandscape } = props;
  const initState = {
    currentScreen: 'Quiz',
    questionIndex: 0,
    initModal: true,
    finished: false,
    currentOptionsShowing: ["DOWNTURN CAUSE", "POLICY", "IMPLEMENTATION"]
  }
  const [isRefreshed, setIsRefreshed] = useState(true);
  const [appState, setAppState] = useState(() => {
    const savedState = localStorage.getItem('slotMachineAppState');
    return savedState && isMobile && !isRefreshed ? JSON.parse(savedState) : initState;
  });

  useEffect(() => {
    localStorage.setItem('slotMachineAppState', JSON.stringify(appState));
  }, [appState]);

  useEffect(() => {
    const lastOrientation = localStorage.getItem('lastOrientation');
    const currentOrientation = isPortrait ? 'portrait': 'landscape';

    if (lastOrientation === currentOrientation) {
      setAppState(initState)
      console.log('page refreshed');
      setIsRefreshed(true)
    } else {
      console.log('daa', appState)
      console.log('Orientation was changed');
    }

    localStorage.setItem('lastOrientation', currentOrientation);
  }, [isPortrait]);

  const updateAppState = (newState) => {
    setAppState(prevState => ({
      ...prevState,
      ...newState
    }));
  };

  // console.log('appState', appState);

  return (
    <div className="App">
      {!isPortrait && <RouterScreen appState={appState} updateAppState={updateAppState} />}
      {isPortrait && <MobileText isOpen={isPortrait} />}
    </div>
  );
}

export default withOrientationChange(App);